import React, { useState, useEffect, useRef } from 'react';
import { STORAGE_KEYS } from '../constants/storageKeys';
import { BASE_URL } from '../constants/config';
import { fetchWithAuth } from '../constants/api';
import { showToast, showAlert } from '../components/Toast';
import AppShell from '../components/AppShell';
import Modal from '../components/Modal';

const GU_NUMS = ['શૂન્ય','એક','બે','ત્રણ','ચાર','પાંચ','છ','સાત','આઠ','નવ','દસ','અગિયાર','બાર','તેર','ચૌદ','પંદર','સોળ','સત્તર','અઢાર','ઓગણીસ','વીસ','એકવીસ','બાવીસ','તેવીસ','ચોવીસ','પચ્ચીસ','છવ્વીસ','સત્તાવીસ','અઠ્ઠાવીસ','ઓગણત્રીસ','ત્રીસ','એકત્રીસ','બત્રીસ','તેત્રીસ','ચોત્રીસ','પાંત્રીસ','છત્રીસ','સાડત્રીસ','આડત્રીસ','ઓગણચાળીસ','ચાળીસ','એકતાળીસ','બેતાળીસ','તેતાળીસ','ચુમ્માળીસ','પિસ્તાળીસ','છેતાળીસ','સુડતાળીસ','અડતાળીસ','ઓગણપચાસ','પચાસ','એકાવન','બાવન','ત્રેપન','ચોપન','પંચાવન','છપ્પન','સત્તાવન','અઠ્ઠાવન','ઓગણસાઠ','સાઠ','એકસઠ','બાસઠ','ત્રેસઠ','ચોસઠ','પાંસઠ','છાસઠ','સડસઠ','અડસઠ','ઓગણસિત્તેર','સિત્તેર','એકોતેર','બોતેર','તે્યોતેર','ચુ્યોતેર','પંચોતેર','છોતેર','સિત્યોતેર','ઈઠ્યોતેર','ઓગણએસી','એસી','એક્યાસી','બ્યાસી','ત્ર્યાસી','ચોર્યાસી','પંચ્યાસી','છ્યાસી','સિત્યાસી','અઠ્યાસી','ઓગણનોવું','નેવું','એકાવણું','બાણું','ત્રેણું','ચોણું','પંચાણું','છન્નું','સત્તાણું','અઠ્ઠાણું','નેવ્વાણું'];

const amountToWords = (amount) => {
  if (!amount) return '';
  const r = Math.floor(amount), p = Math.round((amount - r) * 100);
  const gu = n => {
    if (n===0) return 'શૂન્ય';
    let res = '';
    if (n>=10000000) { res += GU_NUMS[Math.floor(n/10000000)] + ' કરોડ '; n%=10000000; }
    if (n>=100000) { res += GU_NUMS[Math.floor(n/100000)] + ' લાખ '; n%=100000; }
    if (n>=1000) { res += GU_NUMS[Math.floor(n/1000)] + ' હજાર '; n%=1000; }
    if (n>=100) { res += GU_NUMS[Math.floor(n/100)] + ' સો '; n%=100; }
    if (n>0) res += GU_NUMS[n];
    return res.trim();
  };
  let res = gu(r) + ' રૂપિયા';
  if (p>0) res += ' અને ' + gu(p) + ' પૈસા';
  return res + ' માત્ર';
};

const formatINR = v => v == null ? '' : v.toLocaleString('en-IN', { maximumFractionDigits: 2, minimumFractionDigits: 2 });
const todayISO = () => new Date().toISOString().slice(0, 10);

const ExpenseFormScreen = ({ params, onBack }) => {
  const editingExpense = params?.expense || null;
  const isEditing = !!editingExpense;
  const expenseId = editingExpense?.ID || null;
  const getToken = () => localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);

  const [form, setForm] = useState(() => editingExpense ? {
    ID: editingExpense.ID,
    Date: editingExpense.Date ? new Date(editingExpense.Date).toISOString().slice(0, 10) : todayISO(),
    AccountID: editingExpense.AccountID, SubAccountID: editingExpense.SubAccountID, ExpPartyID: editingExpense.ExpPartyID,
    Detail: editingExpense.Detail || '', Narration: editingExpense.Narration || '', Amount: editingExpense.Amount,
    ExpCatID: editingExpense.ExpCatID, ExpSubCatID: editingExpense.ExpSubCatID,
    TransactionType: editingExpense.TransactionType || 'Investment',
  } : {
    ID: null, Date: todayISO(), AccountID: null, SubAccountID: null, ExpPartyID: null,
    Detail: '', Narration: '', Amount: null, ExpCatID: null, ExpSubCatID: null, TransactionType: 'Investment'
  });

  const [amountText, setAmountText] = useState(() => editingExpense?.Amount != null ? String(editingExpense.Amount) : '');
  const [isSaving, setIsSaving] = useState(false);
  const [isAccountLocked, setIsAccountLocked] = useState(false);

  // Accounts
  const [accModal, setAccModal] = useState(false);
  const [accounts, setAccounts] = useState([]);
  const [accLoading, setAccLoading] = useState(false);
  const [selAccName, setSelAccName] = useState(() => editingExpense?.AccountName || '');

  // SubAccounts
  const [subAccModal, setSubAccModal] = useState(false);
  const [subAccounts, setSubAccounts] = useState([]);
  const [subAccLoading, setSubAccLoading] = useState(false);
  const [selSubAccName, setSelSubAccName] = useState(() => editingExpense?.SubAccountName || '');

  // Categories
  const [catSearch, setCatSearch] = useState(() => editingExpense?.ExpCatName || '');
  const [cats, setCats] = useState([]);
  const [catLoading, setCatLoading] = useState(false);
  const [showCatDrop, setShowCatDrop] = useState(false);
  const [selCatName, setSelCatName] = useState(() => editingExpense?.ExpCatName || '');

  // SubCategories
  const [subCatSearch, setSubCatSearch] = useState(() => editingExpense?.ExpSubCatName || '');
  const [subCats, setSubCats] = useState([]);
  const [subCatLoading, setSubCatLoading] = useState(false);
  const [showSubCatDrop, setShowSubCatDrop] = useState(false);
  const [selSubCatName, setSelSubCatName] = useState(() => editingExpense?.ExpSubCatName || '');

  // Parties
  const [partySearch, setPartySearch] = useState(() => editingExpense?.ExpPartyName || '');
  const [parties, setParties] = useState([]);
  const [partyLoading, setPartyLoading] = useState(false);
  const [partyAssocLoading, setPartyAssocLoading] = useState(false);
  const [showPartyDrop, setShowPartyDrop] = useState(false);
  const partyTimeout = useRef(null);

  // Detail suggestions
  const [detailSuggestions, setDetailSuggestions] = useState([]);
  const [showDetailDrop, setShowDetailDrop] = useState(false);

  useEffect(() => {
    const init = async () => {
      const code = localStorage.getItem(STORAGE_KEYS.EMP_CODE)?.toUpperCase();
      if (code === 'W') {
        setIsAccountLocked(true);
        if (!isEditing) {
          const r = await fetchWithAuth(`${BASE_URL}api/Expense/Account/List?onlyActive=true`);
          if (r.ok) {
            const accs = await r.json();
            setAccounts(accs);
            const joj = accs.find(a => a.AccountName.toLowerCase().includes('jewel') || a.AccountName.toLowerCase().includes('joy'));
            if (joj) {
              setSelAccName(joj.AccountName);
              const sr = await fetchWithAuth(`${BASE_URL}api/Expense/SubAccount/List/${joj.ID}?onlyActive=true`);
              if (sr.ok) {
                const subs = await sr.json();
                setSubAccounts(subs);
                const cash = subs.find(s => s.SubAccountName.toLowerCase().includes('cash') || s.SubAccountName.toLowerCase().includes('રોકડ'));
                if (cash) {
                  setSelSubAccName(cash.SubAccountName);
                  setForm(p => ({ ...p, AccountID: joj.ID, SubAccountID: cash.ID }));
                } else setForm(p => ({ ...p, AccountID: joj.ID }));
              }
            }
          }
        }
      }
    };
    init();
  }, [isEditing]);

  const fetchAccounts = async () => {
    if (accounts.length > 0) return;
    setAccLoading(true);
    try {
      const r = await fetchWithAuth(`${BASE_URL}api/Expense/Account/List?onlyActive=true`);
      if (r.ok) setAccounts(await r.json());
    } catch (_) {} finally { setAccLoading(false); }
  };

  const fetchSubAccounts = async (accId) => {
    setSubAccLoading(true);
    try {
      const r = await fetchWithAuth(`${BASE_URL}api/Expense/SubAccount/List/${accId}?onlyActive=true`);
      if (r.ok) { const d = await r.json(); setSubAccounts(d); return d; }
    } catch (_) {} finally { setSubAccLoading(false); }
    return [];
  };

  const fetchCategories = async () => {
    if (cats.length > 0) return cats;
    setCatLoading(true);
    try {
      const r = await fetchWithAuth(`${BASE_URL}api/Expense/Category/List`);
      if (r.ok) { const d = await r.json(); setCats(d); return d; }
    } catch (_) {} finally { setCatLoading(false); }
    return [];
  };

  const fetchSubCategories = async (catId) => {
    setSubCatLoading(true);
    try {
      const r = await fetchWithAuth(`${BASE_URL}api/Expense/SubCategory/List/${catId}`);
      if (r.ok) { const d = await r.json(); setSubCats(d); return d; }
    } catch (_) {} finally { setSubCatLoading(false); }
    return [];
  };

  const handlePartySearch = (text) => {
    setPartySearch(text);
    if (form.ExpPartyID) setForm(p => ({ ...p, ExpPartyID: null }));
    if (partyTimeout.current) clearTimeout(partyTimeout.current);
    if (text.length >= 3) {
      setPartyLoading(true);
      partyTimeout.current = setTimeout(async () => {
        try {
          const r = await fetchWithAuth(`${BASE_URL}api/Expense/Party/List?search=${encodeURIComponent(text)}`);
          if (r.ok) { setParties(await r.json()); setShowPartyDrop(true); }
        } catch (_) {} finally { setPartyLoading(false); }
      }, 500);
    } else {
      setParties([]); setShowPartyDrop(false); setPartyLoading(false);
    }
  };

  const selectParty = async (party) => {
    setForm(p => ({ ...p, ExpPartyID: party.ID }));
    setPartySearch(party.Name);
    setShowPartyDrop(false);
    setPartyAssocLoading(true);
    try {
      const r = await fetchWithAuth(`${BASE_URL}api/Expense/Party/Associatedacsubaccatandsubcat/${party.ID}`);
      if (r.ok) {
        const assoc = await r.json();
        if (assoc.EXPACCID) {
          const allAccs = accounts.length > 0 ? accounts : await (async () => {
            const tr = await fetchWithAuth(`${BASE_URL}api/Expense/Account/List?onlyActive=true`);
            if (tr.ok) { const d = await tr.json(); setAccounts(d); return d; } return [];
          })();
          const acc = allAccs.find(a => a.ID === assoc.EXPACCID);
          if (acc) {
            setSelAccName(acc.AccountName); setForm(p => ({ ...p, AccountID: acc.ID, SubAccountID: null })); setSelSubAccName('');
            if (assoc.EXPSubACCID) {
              const allSubs = await fetchSubAccounts(acc.ID);
              const sub = allSubs?.find(s => s.ID === assoc.EXPSubACCID);
              if (sub) { setSelSubAccName(sub.SubAccountName); setForm(p => ({ ...p, SubAccountID: sub.ID })); }
            }
          }
        }
        if (assoc.ExpenseCatID) {
          const allCats = cats.length > 0 ? cats : await fetchCategories();
          const cat = allCats.find(c => c.ID === assoc.ExpenseCatID);
          if (cat) {
            setSelCatName(cat.Category); setCatSearch(cat.Category); setForm(p => ({ ...p, ExpCatID: cat.ID, ExpSubCatID: null }));
            setSelSubCatName(''); setSubCatSearch(''); setSubCats([]);
            if (assoc.ExpenseSubCatID) {
              const allSubCats = await fetchSubCategories(cat.ID);
              const subCat = allSubCats?.find(sc => sc.ID === assoc.ExpenseSubCatID);
              if (subCat) { setSelSubCatName(subCat.SubCategory); setSubCatSearch(subCat.SubCategory); setForm(p => ({ ...p, ExpSubCatID: subCat.ID })); }
            }
          }
        }
        if (assoc.TransactionType) setForm(p => ({ ...p, TransactionType: assoc.TransactionType }));
        if (Array.isArray(assoc.Details) && assoc.Details.length > 0) {
          setDetailSuggestions(assoc.Details.filter(d => typeof d === 'string' && d.trim() !== ''));
        } else {
          setDetailSuggestions([]);
        }
      }
    } catch (_) {} finally { setPartyAssocLoading(false); }
  };

  const handleSave = async () => {
    if (!form.Amount || form.Amount <= 0) return showAlert('Validation Error', 'Amount must be greater than zero.');
    if (!partySearch.trim()) return showAlert('Validation Error', 'Expense Party is required.');
    if (!form.AccountID || !selAccName.trim()) return showAlert('Validation Error', 'Select an Account.');
    if (!form.SubAccountID || !selSubAccName.trim()) return showAlert('Validation Error', 'Select a Sub Account.');
    if (!selCatName.trim() && !catSearch.trim()) return showAlert('Validation Error', 'Expense Category is required.');
    if (!selSubCatName.trim() && !subCatSearch.trim()) return showAlert('Validation Error', 'Expense Sub Category is required.');

    setIsSaving(true);
    try {
      const payload = {
        ID: form.ID, Date: form.Date ? new Date(form.Date).toISOString() : new Date().toISOString(),
        AccountID: form.AccountID, SubAccountID: form.SubAccountID,
        ExpPartyID: form.ExpPartyID, PartyName: partySearch.trim() || null,
        Detail: form.Detail?.trim() || null, Narration: form.Narration?.trim() || null, Amount: form.Amount,
        ExpCatID: form.ExpCatID, ExpCategory: selCatName.trim() || catSearch.trim() || null,
        ExpSubCatID: form.ExpSubCatID, ExpSubCategory: selSubCatName.trim() || subCatSearch.trim() || null,
        TransactionType: form.TransactionType || 'Investment',
      };
      const r = await fetchWithAuth(`${BASE_URL}api/Expense/${isEditing ? 'Edit' : 'Add'}`, {
        method: isEditing ? 'PUT' : 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (r.ok) { showToast(isEditing ? 'Expense updated.' : 'Expense saved.', 'success'); onBack(); }
      else {
        let msg = `Server error (${r.status})`;
        try { const err = await r.json(); if (err?.message) msg = err.message; } catch (_) {}
        showAlert('Error', msg);
      }
    } catch (_) { showAlert('Error', 'Failed to save expense.'); } finally { setIsSaving(false); }
  };

  const handleDelete = () => {
    showAlert('Delete Expense', 'Are you sure you want to delete this expense?', [
      { text: 'Cancel', style: 'cancel' },
      { text: 'Delete', style: 'destructive', onPress: async () => {
        setIsSaving(true);
        try {
          const r = await fetchWithAuth(`${BASE_URL}api/Expense/Delete/${expenseId}`, { method: 'DELETE' });
          if (r.ok) { showToast('Expense deleted.', 'success'); onBack(); }
          else showAlert('Error', 'Failed to delete expense.');
        } catch (_) { showAlert('Error', 'Failed to delete expense.'); } finally { setIsSaving(false); }
      }}
    ]);
  };

  return (
    <AppShell title={isEditing ? 'Edit Expense' : 'Add Expense'} onBack={onBack}>
      <div style={{ padding: 12, paddingBottom: 40 }}>
        <div style={{ background: '#fff', borderRadius: 12, padding: 16, boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>

          {/* Amount */}
          <div className="row gap-8 mb-12">
            <div className="form-group flex-1" style={{ marginBottom: 0 }}>
              <label className="form-label">Amount</label>
              <div className="form-input-wrap">
                <input className="form-input" type="text" inputMode="decimal" placeholder="0.00" value={amountText} style={{ paddingLeft: 30 }}
                  onChange={e => {
                    const raw = e.target.value.replace(/[^0-9.]/g, '');
                    const p = raw.split('.'); const s = p.length > 2 ? `${p[0]}.${p.slice(1).join('')}` : raw;
                    setAmountText(s); const v = parseFloat(s); setForm(prev => ({ ...prev, Amount: isNaN(v) ? null : v }));
                  }} />
                <span style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)' }}>₹</span>
              </div>
            </div>
            <div className="flex-1" style={{ paddingTop: 20 }}>
              {form.Amount > 0 && (
                <>
                  <div style={{ fontSize: 13, fontWeight: 700, color: '#1a6e2e' }}>₹ {formatINR(form.Amount)}</div>
                  <div style={{ fontSize: 11, color: '#555', fontStyle: 'italic', lineHeight: 1.2 }}>{amountToWords(form.Amount)}</div>
                </>
              )}
            </div>
          </div>

          {/* Party */}
          <div className="form-group dropdown-container">
            <label className="form-label">Expense Party</label>
            <div className="form-input-wrap">
              <input className="form-input" value={partySearch} onChange={e => handlePartySearch(e.target.value)} onFocus={() => setPartySearch(partySearch)} onBlur={() => setTimeout(() => setShowPartyDrop(false), 200)} />
              <span className="form-input-wrap__icon">{partyLoading || partyAssocLoading ? <div className="spinner spinner--dark" style={{ width: 16, height: 16, borderWidth: 2 }} /> : '🔍'}</span>
            </div>
            {showPartyDrop && parties.length > 0 && (
              <div className="dropdown-list">
                {parties.map(p => (
                  <div key={p.ID} className="dropdown-item" onMouseDown={(e) => { e.preventDefault(); selectParty(p); }}>
                    <div className="dropdown-item__text"><div className="dropdown-item__name">{p.Name}</div><div className="dropdown-item__sub">{p.ContactNo || p.Address}</div></div>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="form-group dropdown-container">
            <label className="form-label">Detail</label>
            <input className="form-input" value={form.Detail}
              onChange={e => {
                setForm(p => ({ ...p, Detail: e.target.value }));
                setShowDetailDrop(detailSuggestions.length > 0);
              }}
              onFocus={() => { if (detailSuggestions.length > 0) setShowDetailDrop(true); }}
              onBlur={() => setTimeout(() => setShowDetailDrop(false), 200)}
            />
            {showDetailDrop && (
              <div className="dropdown-list">
                {detailSuggestions.filter(d => typeof d === 'string' && d.toLowerCase().includes(form.Detail.toLowerCase())).map((d, i) => (
                  <div key={i} className="dropdown-item" onMouseDown={e => {
                    e.preventDefault();
                    setForm(p => ({ ...p, Detail: d }));
                    setShowDetailDrop(false);
                  }}>
                    <div className="dropdown-item__text"><div className="dropdown-item__name">{d}</div></div>
                    {form.Detail === d && <span style={{ color: '#C8973A' }}>✓</span>}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Transaction Type Segmented Control */}
          <div className="segmented-control">
            <button className={`segmented-btn ${form.TransactionType === 'Verantage' ? 'segmented-btn--active' : ''}`} onClick={() => setForm(p => ({...p, TransactionType: 'Verantage'}))}>➖ Verantage</button>
            <button className={`segmented-btn ${form.TransactionType === 'Investment' ? 'segmented-btn--active' : ''}`} onClick={() => setForm(p => ({...p, TransactionType: 'Investment'}))}>➕ Investment</button>
          </div>

          <div className="form-group"><label className="form-label">Date</label><input className="form-input" type="date" value={form.Date} max={todayISO()} onChange={e => setForm(p => ({ ...p, Date: e.target.value }))} /></div>

          {/* Account */}
          <div className="form-group">
            <label className="form-label">Account</label>
            <div className="form-input-wrap">
              <input className={`form-input ${isAccountLocked ? 'form-input--locked' : 'form-input--readonly'}`} readOnly value={selAccName || (form.AccountID ? `Account ${form.AccountID}` : '')} onClick={() => !isAccountLocked && (setAccModal(true), fetchAccounts())} />
              <span className="form-input-wrap__icon">{isAccountLocked ? '🔒' : '▾'}</span>
            </div>
          </div>

          {/* Sub Account */}
          <div className="form-group">
            <label className="form-label">Sub Account</label>
            <div className="form-input-wrap">
              <input className={`form-input ${isAccountLocked || !form.AccountID ? 'form-input--locked' : 'form-input--readonly'}`} readOnly value={selSubAccName || (form.SubAccountID ? `SubAccount ${form.SubAccountID}` : '')} onClick={() => !isAccountLocked && form.AccountID && (setSubAccModal(true), fetchSubAccounts(form.AccountID))} />
              <span className="form-input-wrap__icon">{isAccountLocked ? '🔒' : '▾'}</span>
            </div>
          </div>

          {/* Category */}
          <div className="form-group dropdown-container">
            <label className="form-label">Expense Category</label>
            <div className="form-input-wrap">
              <input className="form-input" value={catSearch}
                onChange={e => {
                  setCatSearch(e.target.value);
                  if (form.ExpCatID) { setForm(p => ({ ...p, ExpCatID: null, ExpSubCatID: null })); setSubCatSearch(''); setSelSubCatName(''); setSubCats([]); }
                  const q = e.target.value.toLowerCase();
                  if (q) setShowCatDrop(true); else setShowCatDrop(false);
                }}
                onFocus={async () => {
                  const all = cats.length > 0 ? cats : await fetchCategories();
                  if (all.length > 0) setShowCatDrop(true);
                }}
                onBlur={() => setTimeout(() => setShowCatDrop(false), 200)}
              />
              <span className="form-input-wrap__icon">{catLoading ? <div className="spinner spinner--dark" style={{ width: 16, height: 16, borderWidth: 2 }} /> : '▾'}</span>
            </div>
            {showCatDrop && cats.length > 0 && (
              <div className="dropdown-list">
                {cats.filter(c => c.Category.toLowerCase().includes(catSearch.toLowerCase())).map(c => (
                  <div key={c.ID} className="dropdown-item" onMouseDown={(e) => {
                    e.preventDefault(); setForm(p => ({ ...p, ExpCatID: c.ID, ExpSubCatID: null })); setSelCatName(c.Category); setCatSearch(c.Category);
                    setShowCatDrop(false); setSelSubCatName(''); setSubCatSearch(''); setSubCats([]); fetchSubCategories(c.ID);
                  }}>
                    <div className="dropdown-item__text"><div className="dropdown-item__name">{c.Category}</div></div>
                    {form.ExpCatID === c.ID && <span style={{color: '#C8973A'}}>✓</span>}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Sub Category */}
          <div className="form-group dropdown-container">
            <label className="form-label">Sub Category</label>
            <div className="form-input-wrap">
              <input className={`form-input ${!form.ExpCatID && !catSearch.trim() ? 'form-input--locked' : ''}`} disabled={!form.ExpCatID && !catSearch.trim()} value={subCatSearch}
                onChange={e => {
                  setSubCatSearch(e.target.value);
                  if (form.ExpSubCatID) setForm(p => ({ ...p, ExpSubCatID: null }));
                  const q = e.target.value.toLowerCase();
                  if (q) setShowSubCatDrop(true); else setShowSubCatDrop(false);
                }}
                onFocus={async () => {
                  const all = subCats.length > 0 ? subCats : (form.ExpCatID ? await fetchSubCategories(form.ExpCatID) : []);
                  if (all.length > 0) setShowSubCatDrop(true);
                }}
                onBlur={() => setTimeout(() => setShowSubCatDrop(false), 200)}
              />
              <span className="form-input-wrap__icon">{subCatLoading ? <div className="spinner spinner--dark" style={{ width: 16, height: 16, borderWidth: 2 }} /> : '▾'}</span>
            </div>
            {showSubCatDrop && subCats.length > 0 && (
              <div className="dropdown-list">
                {subCats.filter(sc => sc.SubCategory.toLowerCase().includes(subCatSearch.toLowerCase())).map(sc => (
                  <div key={sc.ID} className="dropdown-item" onMouseDown={(e) => {
                    e.preventDefault(); setForm(p => ({ ...p, ExpSubCatID: sc.ID })); setSelSubCatName(sc.SubCategory); setSubCatSearch(sc.SubCategory); setShowSubCatDrop(false);
                  }}>
                    <div className="dropdown-item__text"><div className="dropdown-item__name">{sc.SubCategory}</div></div>
                    {form.ExpSubCatID === sc.ID && <span style={{color: '#C8973A'}}>✓</span>}
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="form-group"><label className="form-label">Narration</label><textarea className="form-input" value={form.Narration} onChange={e => setForm(p => ({ ...p, Narration: e.target.value }))} rows={2} /></div>

          <div className="row gap-8 mt-16">
            {isEditing && <button className="btn-primary btn-danger-outline flex-1" onClick={handleDelete} disabled={isSaving}>Delete</button>}
            <button className="btn-primary flex-1" style={isEditing ? { flex: 2 } : {}} onClick={handleSave} disabled={isSaving}>
              {isSaving ? <div className="spinner" /> : (isEditing ? 'Update Expense' : 'Save Expense')}
            </button>
          </div>

        </div>
      </div>

      <Modal visible={accModal} onDismiss={() => setAccModal(false)} title="Select Account">
        {accLoading ? <div className="loading-screen" style={{ minHeight: 100 }}><div className="spinner spinner--gold" /></div> : accounts.map(a => (
          <div key={a.ID} className="list-item" onClick={() => { setForm(p => ({ ...p, AccountID: a.ID, SubAccountID: null })); setSelAccName(a.AccountName); setSelSubAccName(''); setAccModal(false); fetchSubAccounts(a.ID); }}>
            <div className="list-item__text"><div className="list-item__title">{a.AccountName}</div><div className="list-item__sub">{a.ACType}</div></div>
            {form.AccountID === a.ID && <span className="list-item__check">✓</span>}
          </div>
        ))}
      </Modal>

      <Modal visible={subAccModal} onDismiss={() => setSubAccModal(false)} title="Select Sub Account">
        {subAccLoading ? <div className="loading-screen" style={{ minHeight: 100 }}><div className="spinner spinner--gold" /></div> : subAccounts.map(s => (
          <div key={s.ID} className="list-item" onClick={() => { setForm(p => ({ ...p, SubAccountID: s.ID })); setSelSubAccName(s.SubAccountName); setSubAccModal(false); }}>
            <div className="list-item__text"><div className="list-item__title">{s.SubAccountName}</div><div className="list-item__sub">{s.ACType}</div></div>
            {form.SubAccountID === s.ID && <span className="list-item__check">✓</span>}
          </div>
        ))}
      </Modal>
    </AppShell>
  );
};

export default ExpenseFormScreen;
